module.exports = __webpack_public_path__ + "img/aiesec.b44ec084.png";